const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapsAndFlags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#c2b68e",
    d: "M 24.5,-0.5 C 26.5,-0.5 28.5,-0.5 30.5,-0.5C 26.5271,0.602061 22.5271,1.93539 18.5,3.5C 20.1898,1.65832 22.1898,0.324982 24.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4e4e3",
    d: "M 30.5,-0.5 C 33.1667,-0.5 35.8333,-0.5 38.5,-0.5C 53.3096,6.39734 58.143,17.7307 53,33.5C 47.8516,44.4615 41.3516,54.4615 33.5,63.5C 32.1667,63.5 30.8333,63.5 29.5,63.5C 19.2023,52.6788 12.0357,40.0121 8,25.5C 7.0268,15.8714 10.5268,8.53803 18.5,3.5C 22.5271,1.93539 26.5271,0.602061 30.5,-0.5 Z M 40.5,15.5 C 40.3284,16.4916 40.6618,17.1583 41.5,17.5C 41.5569,18.609 41.8902,19.609 42.5,20.5C 42.5946,23.6967 41.9279,26.6967 40.5,29.5C 39.5,29.8333 38.8333,30.5 38.5,31.5C 35.418,33.181 32.0847,33.8476 28.5,33.5C 26.6675,32.7515 25.0009,31.7515 23.5,30.5C 19.3804,24.6392 19.7138,18.9726 24.5,13.5C 30.2989,10.4666 35.6323,11.1333 40.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.325
    },
    fill: "#ce8382",
    d: "M 40.5,15.5 C 35.6323,11.1333 30.2989,10.4666 24.5,13.5C 30.3921,9.27224 36.0587,9.77224 41.5,15C 41.2716,15.3988 40.9382,15.5654 40.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.682
    },
    fill: "#ae4ec3",
    d: "M 42.5,20.5 C 41.8902,19.609 41.5569,18.609 41.5,17.5C 41.4346,17.0618 41.6012,16.7284 42,16.5C 43.298,17.9456 43.4646,19.2789 42.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.882
    },
    fill: "#8c86ce",
    d: "M 40.5,29.5 C 40.631,30.2389 40.4643,30.9056 40,31.5C 39.31,32.7383 38.81,32.7383 38.5,31.5C 38.8333,30.5 39.5,29.8333 40.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.604
    },
    fill: "#92a6dd",
    d: "M 23.5,30.5 C 25.0009,31.7515 26.6675,32.7515 28.5,33.5C 27.2789,34.4646 25.9456,34.298 24.5,33C 23.7476,32.3292 23.4142,31.4959 23.5,30.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsAndFlags);
export default __webpack_public_path__ + "static/media/maps-and-flags.a63f80222d3c6c0a9712b53cc8259bd2.svg";
export { ForwardRef as ReactComponent };